const state = {
  strWebSiteId: '78dc61c9ee904ce79ef51057f9219342'
}

export default state
